import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import { buildSubscriptionHref } from 'Pods/ThreeDStudio/Shared/UsageBodies/constants'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

export function useSubscriptionHref() {
  const subscriptionPaymentFormUrl = useThreeDStudioStore(
    state => state.subscription.subscriptionPaymentFormUrl
  )
  // The store URL is only hydrated for signed-in users (useHydrateGenerationQuota bails when
  // logged out). Signed-out visitors read the same key from window.pageConfig instead, so the
  // upsell CTA gets the absolute (subdomain-qualified) payment-form URL and does not 404 against
  // the subscriptions-only route.
  const pageConfig = usePageConfig()

  return buildSubscriptionHref(
    subscriptionPaymentFormUrl || pageConfig?.threeDStudioSubscriptionPaymentFormUrl
  )
}
